import "../styles/Form.scss";
import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../models/ValidationSchema";
import DatePicker, { setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NumericFormat } from "react-number-format";
import { countries, channelLists } from "../data/Data";
import { formatDate } from "../components/FormatDate";
import { convertBase64 } from "../components/ConvertBase64";
import { submitForm } from "../api/apiManagement";
import { GlobalContext } from "../App";
import Popup from "../components/Popup";

function Form() {
  const {
    isLoading,
    setIsLoading,
    currentFormStep,
    setCurrentFormStep,
    phase,
    setPhase,
  } = useContext(GlobalContext);



  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    control,
    setError,
  } = useForm({
    defaultValues: {
      select: { value: "852", label: "+852" },
    },
    resolver: yupResolver(validationSchema),
  });
  const [popup, setPopup] = useState("0");

  const [selectDate, setSelectDate] = useState(null);

  const [files, setFiles] = useState({
    file1: { fileName: "", fileBase64: "" },
    file2: { fileName: "", fileBase64: "" },
  });

  // const [duplicateEmail, setDuplicateEmail] = useState("");

  const selectValue = watch("select.value");

  function handleFileChange(event, fileObject) {
    const file = event.target.files[0];
    convertBase64(file)
      .then((base64Data) => {
        setFiles((prevState) => ({
          ...prevState,
          [fileObject]: {
            ...prevState[fileObject],
            fileName: file.name,
            fileBase64: base64Data,
          },
        }));
      })
      .catch((error) => {
        console.error("Error converting file to Base64:", error);
      });
  }

  const onSubmitHandler = (data) => {
    console.log(data);
    console.log(data.select.value);
    let submitData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.select.value + data.mobile,
      newsLetter: data.newsLetter ? 1 : 0,
      lang: "en",
      purchaseDate: formatDate(data.purchaseDate),
      totalAmount: 0,
      invoiceNum: data.invoiceNumber,
      purchaseChannel: 0,
      txtChannel: data.txtChannel,
      invoice1: files.file1.fileBase64,
      invoice2: files.file2.fileBase64,
      txtArea: data.gameAnswer,
    };
    console.log(submitData);

    setIsLoading(true);

    submitForm(submitData)
      .then((res) => {
        console.log(res);
        const currentStatus = res.data.status;

        if (currentStatus === "200") {
          setIsLoading(false);
          setPhase(res.data.data);
          setCurrentFormStep(2);
        }

        if (currentStatus === "500") {
          setIsLoading(false);
          setError(
            "fileInvoice1",
            {
              type: "manual",
              message:
                "File upload failed. Please re-upload.  上載失敗。請重新上載。 ",
            },
            { shouldFocus: true }
          );
          setError(
            "fileInvoice2",
            {
              type: "manual",
              message:
                "File upload failed. Please re-upload.  上載失敗。請重新上載。",
            },
            { shouldFocus: true }
          );
        }
        if (currentStatus === "501") {
          setIsLoading(false);
          setError(
            "invoiceNumber",
            {
              type: "manual",
              message: "Please input valid IMEI# 請輸入有效IMEI#",
            },
            { shouldFocus: true }
          );
        }

        if (currentStatus === "502") {
          setIsLoading(false);
          // setError(
          //   "invoiceNumber",
          //   {
          //     type: "manual",
          //     message:
          //       "每個IMEI#只可提交一次 Each IMEI# can be submitted once only",
          //   },
          //   { shouldFocus: true }
          // );
          setPopup("502");
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return (
    <div className="form-page-container">
      {popup === "502" ? (
        <Popup
          title={""}
          buttonLeftText={""}
          buttonRightText={""}
          haveButton={false}
          detail={[
            "請輸入有效購買日期                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  ",
            "Please input valid purchase date",
          ]}
          haveCloseButton={true}
          popupStatus={() => setPopup("0")}
        />
      ) : (
        <></>
      )}

      <form className="form-container" onSubmit={handleSubmit(onSubmitHandler)}>
        {/* Last Name 姓氏  First Name 名字 */}
        <div className="input-row">
          <div className="input-container">
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                姓氏(須與香港或澳門身份證所示一致)<br></br> Last Name (Must be
                the same as on Hong Kong or Macau Identity Card)
              </div>
            </div>
            <input
              className="input-box"
              type="text"
              placeholder=""
              {...register("lastName", { required: true })}
            />
            {errors.lastName && (
              <span className="input-error-message">
                {errors.lastName?.message}
              </span>
            )}
          </div>
          <div className="input-container">
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>
                名字 (須與香港或澳門身份證所示一致)
                <br></br>First Name (Must be the same as on Hong Kong or Macau
                Identity Card)
              </div>
            </div>
            <input
              className="input-box"
              type="text"
              {...register("firstName", { required: true })}
            />
            {errors.firstName && (
              <span className="input-error-message">
                {errors.firstName?.message}
              </span>
            )}
          </div>
        </div>
        {/* Last Name 姓氏  First Name 名字 */}
        {/* 手提號碼 電郵地址*/}
        <div className="input-row">
          <div className="input-container">
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span> 流動電話號碼 Mobile Number
              </div>
            </div>
            <div className="mobile-input-box-container">
              <Controller
                control={control}
                className="mobile-dropdown-list"
                name="select.value"
                render={({ value, ref, field }) => (
                  <Select
                    {...field}
                    inputRef={ref}
                    classNamePrefix="dropdown-class-countries"
                    options={countries}
                    defaultValue={{ label: "+852", value: "852" }}
                    value={countries.find((c) => c.value === value)}
                    onChange={(val) => field.onChange(val.value)}
                    isSearchable={false}
                  />
                )}
              />
              <input
                className="input-box"
                type="tel"
                maxLength={11}
                {...register("mobile", { required: true })}
              />
            </div>
            {errors.mobile && (
              <span className="input-error-message">
                {errors.mobile.message}
              </span>
            )}
          </div>
          <div className="input-container">
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span> 電郵地址 Email Address
              </div>
            </div>
            <input
              className="input-box"
              type="email"
              {...register("email", {
                required: true,
              })}
            />
            {errors.email && (
              <span className="input-error-message">
                {errors.email.message}
              </span>
            )}
          </div>
        </div>
        {/* 手提號碼 電郵地址*/}
        {/**購買日期 */}
        <div className="input-row">
          <div className="input-container">
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span> 購買日期 Purchase Date
              </div>
            </div>
            <Controller
              name="purchaseDate"
              control={control}
              rules={{ required: true }}
              render={({ value, ref, field }) => (
                <DatePicker
                  readonly="readonly"
                  className="datepicker"
                  {...field}
                  inputRef={ref}
                  selected={selectDate}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="請選擇日期 Please select Purchase Date"
                  // placeholderText="YYYY-MM-DD"
                  onChange={(date) => {
                    field.onChange(date);
                    setSelectDate(date);
                  }}
                  value={(date) => setSelectDate(date)}
                  minDate={new Date("2025-09-07")}
                  maxDate={new Date()}
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                />
              )}
            />
            {errors.purchaseDate && (
              <span className="input-error-message">
                {errors.purchaseDate.message}
              </span>
            )}
          </div>
        </div>
        {/**購買日期 */}
        {/**總金額*/}
        {/* <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>Total Purchase Amount
                (Single Transaction) <br></br>總購買金額 (單一交易)
              </div>
            </div>
            <Controller
              name="totalPurchaseAmount"
              control={control}
              rules={{ required: true }}
              render={({ value, ref, field }) => (
                <NumericFormat
                  className="input-box"
                  {...field}
                  // getInputRef={ref}
                  inputRef={ref}
                  name="totalPurchaseAmount"
                  displayType="input"
                  onValueChange={(values, sourceInfo) => {
                    console.log(values, sourceInfo);
                  }}
                />
              )}
            />
            {errors.totalPurchaseAmount && (
              <span className="input-error-message">
                {errors.totalPurchaseAmount.message}
              </span>
            )}
          </div>
        </div> */}
        {/**總金額*/}
        {/**單據編號 */}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span> IMEI#
                (於指定期内購買的Galaxy Z Fold7 或 Z Flip7 ) <br></br>IMEI#
                (Galaxy Z Fold7 or Z Flip7 purchased within the designated
                period)
              </div>
            </div>
            <input
              className="input-box"
              type="text"
              {...register("invoiceNumber", {
                required: true,
                minLength: {
                  value: 15,
                },
                maxLength: {
                  value: 15,
                },
              })}
            />
            {errors.invoiceNumber && (
              <span className="input-error-message">
                {errors.invoiceNumber.message}
              </span>
            )}
          </div>
        </div>
        {/**單據編號 */}
        {/* 購買店鋪*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span> 購買渠道<br></br> Purchase
                Channel
              </div>
            </div>
            <input
              className="input-box"
              type="text"
              placeholder=""
              {...register("txtChannel", { required: true })}
            />
            {errors.txtChannel && (
              <span className="input-error-message">
                {errors.txtChannel?.message}
              </span>
            )}
            {/* <div className="mobile-input-box-container">
              <div style={{ width: "100%" }}>
                <Controller
                  control={control}
                  className="mobile-dropdown-list"
                  name="purchaseChannel"
                  render={({ value, ref, field }) => (
                    <Select
                      {...field}
                      inputRef={ref}
                      classNamePrefix="dropdown-class-channels"
                      options={channelLists}
                      placeholder="請選擇 Please select"
                      value={channelLists.find((c) => c.value === value)}
                      onChange={(val) => field.onChange(val.value)}
                      isSearchable={false}
                    />
                  )}
                />
              </div>
            </div> */}
            {errors.purchaseChannel && (
              <span className="input-error-message">
                {errors.purchaseChannel.message}
              </span>
            )}
          </div>
        </div>
        {/* 購買店鋪*/}
        {/* 上載購買單據 1 & 2 */}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>
                上傳單據照片<br></br>Upload Receipt Image
                <br></br>
                <span className="input-label2">
                  (檔案上載必須少於6MB，只接受JPEG或PNG 格式。 File uploads must be smaller than 6MB and only accept JPEG or PNG format.)
                </span>
              </div>
            </div>
            <div className="input-box ">
              <div className="upload-file-box">
                {files.file1.fileName == "" ? (
                  <span className="upload-text">
                    選擇購買單據 Select purchase receipt
                  </span>
                ) : (
                  <span className="upload-text">{files.file1.fileName}</span>
                )}
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdlMTUwYy1iNTJhLTQxZmUtYmQwYS04MDljMWMwMjQ5NTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjA1QTBGQkMzNUM2MTFFOUIwMkVCMEM0OTU0RUUzQkEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjA1QTBGQkIzNUM2MTFFOUIwMkVCMEM0OTU0RUUzQkEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODExYjBhOGUtMTNlYi00MTc5LTk3NDItOTI5ZjE5NmZiNTJmIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmJlN2UxNTBjLWI1MmEtNDFmZS1iZDBhLTgwOWMxYzAyNDk1MyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpdKhDsAAADHSURBVHjaYvz//z8DNQETA5XB4DeQBcZgZGTEpSYJSs/DJokRByABPBFjCMTfoNgQl4HIGJ+BAkB8F6QHiu9CxcgyEOT/DUiGwfAmqBzJBpZjMQyGK0g10AGI/+Ax8A9UDVEGSgHxCzyGwfALqFq8BrIC8WEiDINhkFpWfAb2kmAYDPfhMxCUJAShOBWPIalI6gTQDWRBiowPSOyveHIXSO79aGmDyGKwNIintMEL0HMZ7cpDdIsJ+Yz+YTha640aOIAGAgQYAKa1+uaT/hgRAAAAAElFTkSuQmCC"
                  className="upload-icon"
                ></img>
              </div>
              <input
                className="upload-file"
                type="file"
                {...register("fileInvoice1", {
                  onChange: (e) => {
                    handleFileChange(e, "file1");
                    console.log(e.target.files[0]);
                  },
                  required: true,
                })}
              />
            </div>
            {errors.fileInvoice1 && (
              <span className="input-error-message">
                {errors.fileInvoice1?.message}
              </span>
            )}
          </div>
          <div className="input-container" style={{ display: "none" }}>
            <div className="input-label-container">
              <div className="input-label">
                {/* <span className="red-start">*</span>*/}
                Upload Receipt Image #2 (Each receipt can be submitted once
                only) <span className="red">*Up to 6MB</span>
                <br></br>
                上傳單據照片 #2 (每張單據只可提交一次){" "}
                <span className="red">*6MB為上限</span>
              </div>
            </div>
            <div className="input-box">
              <div className="upload-file-box">
                {files.file2.fileName == "" ? (
                  <span className="upload-text">
                    Select purchase receipt 選擇購買單據
                  </span>
                ) : (
                  <span className="upload-text">{files.file2.fileName}</span>
                )}
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdlMTUwYy1iNTJhLTQxZmUtYmQwYS04MDljMWMwMjQ5NTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjA1QTBGQkMzNUM2MTFFOUIwMkVCMEM0OTU0RUUzQkEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjA1QTBGQkIzNUM2MTFFOUIwMkVCMEM0OTU0RUUzQkEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODExYjBhOGUtMTNlYi00MTc5LTk3NDItOTI5ZjE5NmZiNTJmIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmJlN2UxNTBjLWI1MmEtNDFmZS1iZDBhLTgwOWMxYzAyNDk1MyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpdKhDsAAADHSURBVHjaYvz//z8DNQETA5XB4DeQBcZgZGTEpSYJSs/DJokRByABPBFjCMTfoNgQl4HIGJ+BAkB8F6QHiu9CxcgyEOT/DUiGwfAmqBzJBpZjMQyGK0g10AGI/+Ax8A9UDVEGSgHxCzyGwfALqFq8BrIC8WEiDINhkFpWfAb2kmAYDPfhMxCUJAShOBWPIalI6gTQDWRBiowPSOyveHIXSO79aGmDyGKwNIintMEL0HMZ7cpDdIsJ+Yz+YTha640aOIAGAgQYAKa1+uaT/hgRAAAAAElFTkSuQmCC"
                  className="upload-icon"
                ></img>
              </div>
              <input
                className="upload-file"
                type="file"
                {...register("fileInvoice2", {
                  onChange: (e) => {
                    handleFileChange(e, "file2");
                  },
                })}
              />
            </div>
            {errors.fileInvoice2 && (
              <span className="input-error-message">
                {errors.fileInvoice2?.message}
              </span>
            )}
          </div>
        </div>
        {/*  上載購買單據 1 & 2  */}
        <br></br>
        {/**單據編號 */}
        <div className="input-row">
          <div
            className="input-container"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="input-label-container">
            {phase == 2 ? (
                  <div className="input-label">
                    <span className="red-start">*</span>
                    如果Galaxy AI為您策劃一場演唱會，您希望是怎樣的演唱會？
                    <br></br>
                    If Galaxy AI could plan a concert just for you, what would you want it to be like?
                </div>
              ) : (
                  <div className="input-label">
                  <span className="red-start">*</span>
                  您會如何運用 Galaxy AI
                  來創作有趣的社交媒體內容及提升您在演唱會中的體驗?
                  <br></br>
                  How would you use Galaxy AI to create engaging social media
                  content and enhance your experience at a music concert?
                </div>
              )}

            </div>
            <textarea
              placeholder=""
              className="textarea"
              rows="10"
              maxLength="4000"
              {...register("gameAnswer", { required: true })}
            />
            {errors.gameAnswer && (
              <span className="input-error-message">
                {errors.gameAnswer.message}
              </span>
            )}
          </div>
        </div>
        {/**單據編號 */}
        {/**私隱政策  */}
        <div className="input-row">
          <div
            className="input-container"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="checkbox-container">
              <div className="input-checkbox-container">
                <input
                  className="input-checkbox"
                  type="checkbox"
                  {...register("privacyPolicy", {
                    required: true,
                  })}
                />
              </div>
              <div className="input-label-container">
                <div className="input-label">
                  <div className="checkbox-text-container">
                    <div className="checkbox-text">
                      <span style={{ color: "red" }}>*</span>
                      本人接受本推廣活動的
                      <a
                        href="https://www.samsung.com/hk/offer/mobile/"
                        target="_blank"
                      >
                        條款及細則
                      </a>
                      。<br></br>I accept the{" "}
                      <a
                        href="https://www.samsung.com/hk_en/offer/mobile/"
                        target="_blank"
                      >
                        Terms and conditions
                      </a>{" "}
                      relating to this promotion.
                    </div>
                    <span
                      className="red-start"
                      style={{ position: "relative", marginLeft: "0px" }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            {errors.privacyPolicy && (
              <span className="input-error-message">
                {errors.privacyPolicy.message}
              </span>
            )}
          </div>
        </div>
        {/**私隱政策 */}
        {/**私隱政策 2 */}
        <div className="input-row">
          <div
            className="input-container"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="checkbox-container">
              <div className="input-checkbox-container">
                <input
                  className="input-checkbox"
                  type="checkbox"
                  {...register("privacyPolicy2", {
                    required: true,
                  })}
                />
              </div>
              <div className="input-label-container">
                <div className="input-label">
                  <div className="checkbox-text-container">
                    <div className="checkbox-text">
                      <span style={{ color: "red" }}>*</span>
                      我了解並同意上述所提供的個人資料將由三星電子香港有限公司（「Samsung」）所收集、使用及保留用作與此活動直接相關的目的（包括但不限於確認我的登記以及接收本活動的通知）。我明白我所提供的個人資料在需要時可能會轉交
                      Samsung
                      的關聯公司及/或其第三方服務供應商（無論在香港或海外）（統稱「使用方」）以作上述用途。我知悉
                      Samsung 將根據《個人資料（私穩）條例》及 Samsung
                      的私穩政策刻理我的個人資料，且本人有權查閱及改正使用方所持關於本人的個人資料，並能透過
                      privacy.sehk@samsung.com 聯絡 Samsung
                      資料私穩主任以提出該等要求。
                      <br></br>I understand and agree that the personal data
                      provided herein will be collected and used by Samsung
                      Electronics H.K. Company Limited (“Samsung”) for the
                      purposes directly related to this event (including but not
                      limited to confirming registration and receiving
                      notification pertaining to this event). I further
                      understand that such personal data may be transferred to
                      Samsung’s affiliates and/or its third party service
                      providers(whether in Hong Kong or abroad)(collectively
                      “Data Users”) where necessary for the above purposes. I
                      acknowledge that Samsung will process my personal data in
                      compliance with the requirements of Personal Data
                      (Privacy) Ordinance and Samsung Privacy Policy, and that I
                      have the right to request access to and correction of my
                      personal data held by Data Users, and such request can be
                      made to Samsung’s Data Privacy Officer at
                      privacy.sehk@samsung.com
                    </div>
                    <span
                      className="red-start"
                      style={{ position: "relative", marginLeft: "0px" }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            {errors.privacyPolicy2 && (
              <span className="input-error-message">
                {errors.privacyPolicy2.message}
              </span>
            )}
          </div>
        </div>
        {/**私隱政策 2*/}
        {/**News Letter  */}
        <div className="input-row">
          <div
            className="input-container"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="checkbox-container">
              <div className="input-checkbox-container">
                <input
                  className="input-checkbox"
                  type="checkbox"
                  {...register("newsLetter", {})}
                />
              </div>
              <div className="input-label-container">
                <div className="input-label">
                  <div className="checkbox-text-container">
                    <div className="checkbox-text">
                      本人希望透過推送通知、短信、WhatsApp 訊息及電子報等 ,
                      收取有關Samsung產品、服務及/或活動的特別優惠及市場推廣訊息。本人明白及同意Samsung將根據其私隱政策使用我上述所提供的個人資料作相關的直接促銷用途。我知悉Samsung需要得到我的同意方可如此使用我的個人資料。
                      <br></br>I would like to receive special offers,
                      promotional and marketing information about Samsung
                      products, services and/or events through push
                      notifications, e-newsletters, WhatsApp and SMS/MMS etc. I
                      understand and agree that Samsung will use my personal
                      data provided herein for the aforesaid direct marketing
                      purposes according to Samsung's Privacy Policy. I
                      understand that Samsung may not so use my personal data
                      unless with my consent.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {errors.newsLetter && (
              <span className="input-error-message">
                {errors.newsLetter.message}
              </span>
            )}
          </div>
        </div>
        {/**News Letter */}
        {/*Submit button */}
        <div className="submit-container">
          <button
            onClick={handleSubmit(onSubmitHandler)}
            value="submit"
            className="submit-button"
          >
            提交 SUBMIT
          </button>
        </div>
      </form>
    </div>
  );
}

export default Form;
